module.exports = __webpack_public_path__ + "img/p2-19.3c4c657d.png";